import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Modal } from 'react-bootstrap';

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import PrintView from './PrintView';
import TransactionComment from './TransactionComment';

function BranchDetailVerify(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);


    const [reqData, setReqData] = useState([]);
    const [docListData, setDocListData] = useState([]);
    const [remark, setRemark] = useState("");
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    const [reqBranchApproved, setReqBranchApproved] = useState(0);
    const [reqAddDetailFinal, setReqAddDetailFinal] = useState(0);
    const [reqDocumentFinal, setReqDocumentFinal] = useState(0);
    const [right, setRight] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'BRANCH_VERIFY_DETAILS'], function (result) {
                let resp = JSON.parse(result);
                setRight(resp);
                if (resp.query === "1") {
                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setReqData(resp1);
                        setDocListData(resp1.req_documentdetail);
                        setReqBranchApproved(resp1.req_branchdetailsverify);
                        setReqAddDetailFinal(resp1.req_adddetailsfinal);
                        setReqDocumentFinal(resp1.req_documentsfinal);
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnComplianceApproveClick() {
        const confirmMsg = 'Are you sure to Verify Branch Details?';
        if (window.confirm(confirmMsg)) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'approvebranchdetails', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqBranchApproved(1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }

    function btnUnlockDetails() {
        if (window.confirm('Are you sure to Unlock Detail ? ')) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'unlockdetail', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqAddDetailFinal(0);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }

    function btnUnlockDocument() {
        if (window.confirm('Are you sure to Unlock Detail ? ')) {
            Common.callApi(Common.apiComplianceApprove, [sid, 'unlockdocument', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqDocumentFinal(0);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }

            });
        }
    }

    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };
    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Branch Details Verify</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PrintView rhdata={reqData}></PrintView>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Document</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                        <td>Upload Timestamp</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                             <td>{res.doc_uploadedat}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    {
                                                       ( res.doc_aws != 1 &&  (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                            || res.doc_ext === "jpg" || res.doc_ext === "png") ) ? <>
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                        </> : null
                                                    }

                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span
                                                                onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid,openDocument)}
                                                                className="pointer colorThemeBlue"
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                    )}
                                                    &nbsp;&nbsp;
                                                    {res.doc_aws == 1 ? (
                                                        <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />

                                                        </span>
                                                    ) :
                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {
                        reqBranchApproved === "0" ?
                            <Row>
                                <Col xs={6}>
                                    <Form.Group >
                                        <Form.Label>Comment</Form.Label>
                                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setRemark)}
                                            value={remark} autoComplete="off" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                    </Form.Group>
                                </Col>
                            </Row>
                            : null
                    }

                    <Row>
                        <Col>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col><b>{reqData.req_bmapproval === "1" ? 'Approved By Branch Manager' : ''}</b></Col>
                        <Col><b>{reqData.req_zmapproval === "1" ? 'Approved By Zonal Head' : ''}</b></Col>
                        <Col><b>{reqData.req_bhapproval === "1" ? 'Approved By Business Head' : ''}</b></Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            {right.add === "1" ?
                                <>
                                    {
                                        (reqBranchApproved === "0" && reqAddDetailFinal === "1" && reqDocumentFinal === "1") ?
                                            <>
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnComplianceApproveClick()} >Approve</Button><span>&nbsp;</span>
                                            </>
                                            : null
                                    }
                                    {
                                        (reqBranchApproved === "0" && reqAddDetailFinal === "1") ?
                                            <>
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnUnlockDetails()} >Unlock Details</Button><span>&nbsp;</span>
                                            </>
                                            : null
                                    }
                                    {/* {
                                        (reqBranchApproved === "0" && reqDocumentFinal === "1") ?
                                            <>
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnUnlockDocument()} >Unlock Document</Button>
                                            </>
                                            : null
                                    } */}

                                </>
                                : null
                            }

                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
    
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default BranchDetailVerify;